import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_stripe_checkout_session_create } from '@/state/workspace/billing/remote_stripe_checkout_session_create';
import { md } from '@/utils/utils_html';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { RequestBuyCredits } from '@shared/dto/+workspace/workspace_payment_transaction.ts/_requests/request_buy_credits';
import { format_compact_number } from '@shared/utils/utils_number';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  amount: number;
}

export const USButtonCreditsAdd = ({ amount }: Props) => {
  const dispatch = use_dispatch();

  const { workspace_current } = use_slice_workspace(['workspace_current']);

  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  async function onClick() {
    let request = new RequestBuyCredits();
    request.credits_amount = amount;
    request.workspace_id = workspace_current._id;

    setIsLoading(true);
    const action_result = await dispatch(remote_stripe_checkout_session_create(request));
    setIsLoading(false);

    if (typeof action_result.payload != 'string') return;

    window.location.href = action_result.payload;
  }

  function render_text() {
    if (isLoading) return <span>...</span>;

    return (
      <span className="w-full h-full text-center flex items-center justify-center flex-col gap-3 text-wrap">
        <span className="text-[30px]">+{format_compact_number(amount)}</span> {t(i18n_page_settings_workspace.tabs.credits.payment_card_component.title)}
        <span className="text-[20px]">{`${amount / (CONSTANTS__shared.CREDITS_PER_USD_CENT_RATE * 100)}$`}</span>
      </span>
    );
  }

  return (
    <UI_PRIMITIVE__button
      className={`h-[150px]  text-page-foreground ${md('max-w-[170px] min-w-[120px] flex-1', 'w-[100px]')}`}
      variant="outline-on-component"
      size="sm"
      onClick={onClick}
      disabled={isLoading}
    >
      {render_text()}
    </UI_PRIMITIVE__button>
  );
};
